<input
    type="button"
    #openModal
    data-bs-toggle="modal"
    data-bs-target="#async-modal"
    class="hidden"
/>

<div
    class="modal fade"
    id="async-modal"
    tabindex="-1"
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" [innerHTML]="asyncModalService.title"></div>
            <div class="modal-footer">
                <ng-container *ngFor="let button of asyncModalService.buttons">
                    <button
                        *ngIf="!button.isHtml"
                        type="button"
                        (click)="hide(button)"
                        [attr.data-bs-dismiss]="
                            button.closeOnClick != false ? 'modal' : ''
                        "
                        class="btn"
                        [ngClass]="
                            button.className ? button.className : 'btn-primary'
                        "
                    >
                        {{ button.label }}
                    </button>
                    <div *ngIf="button.isHtml" [innerHtml]="button.html"></div>
                </ng-container>
                <button
                    type="button"
                    data-bs-dismiss="modal"
                    hidden
                    #closeModal
                ></button>
            </div>
        </div>
    </div>
</div>
